<template>
	<div>
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>数据总览</el-breadcrumb-item>
			<el-breadcrumb-item>考核人数统计</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 卡片视图 -->
		<!-- <el-row :gutter="20" class="flex-wrap">
      <el-col :sm="12" :md="6" class="mb20">
        <el-card>
          <div class="tj-card">
            <i class="fa el-icon-pie-chart fa-3x color-ll"></i>
            <div class="item">
              <div class="item-title">今日参观</div>
              <div class="item-desc">387</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :sm="12" :md="6" class="mb20">
        <el-card>
          <div class="tj-card">
            <i class="fa el-icon-s-order fa-3x color-yh"></i>
            <div class="item">
              <div class="item-title">考核人数</div>
              <div class="item-desc">86</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :sm="12" :md="6" class="mb20">
        <el-card>
          <div class="tj-card">
            <i class="fa el-icon-date fa-3x color-el"></i>
            <div class="item">
              <div class="item-title">月统计</div>
              <div class="item-desc">273</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :sm="12" :md="6" class="mb20 move" >
        <el-card>
          <div class="tj-card">
            <i class="fa el-icon-s-custom fa-3x color-sr"></i>
            <div class="item">
              <div class="item-title">昨日参观</div>
              <div class="item-desc">38732</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row> -->
		<el-row :gutter="30">
			<el-col :xl="24" class="hwg_mb">
				<p>修改考试时间</p>
				<el-input v-model="times" class="hwg_ipt" placeholder="请输入数字"></el-input>
				<el-button type="primary" round @click="hwg_ipt">确认</el-button>
				<span class="el-span">小程序开关</span>
				<el-switch @change="hwg_swt" v-model="xcxSwitchs" active-text="开启" inactive-text="关闭">
				</el-switch>
				<el-button class="examine" type="primary" @click="examines">预约审核查看</el-button>
			</el-col>
			<el-col :xl="24" class="hwg_mb">
				<p>团体预约通知管理员</p>
				<el-input v-model="masterPhone" class="hwg_ipt" placeholder="请输入手机号"></el-input>
				<el-button type="primary" round @click="setup_ipt('masterPhone')">确认</el-button>

				<p>理论考试题目数量</p>
				<el-input v-model="theoryNum" class="hwg_ipt" placeholder="请输入数字"></el-input>
				<el-button type="primary" round @click="setup_ipt('theoryNum')">确认</el-button>
				
			</el-col>
		</el-row>
		<!-- <el-row :gutter="30" class="row_transfer">
      <el-col :xl="24">
        <el-button type="primary" @click="hwg_transfers">确认考题</el-button>
          <el-transfer
            v-model="hwg_transfer"
            :props="{
              key: 'value',
              label: 'label'
            }"
            :data="transfer">
          </el-transfer>
      </el-col>
    </el-row> -->
		<el-dialog title="提示" :visible.sync="wexamines" width="70%">
			<el-button class="examine" type="primary" @click="adoptexamines">通过审核</el-button>
			<el-button class="examine" type="danger" @click="refuseexamines">拒审</el-button>
			<el-table :data="wgexamines">
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column class="text" prop="username" label="预约姓名"> </el-table-column>
				<el-table-column class="text" prop="mobile" label="预约手机"> </el-table-column>
				<el-table-column class="text" prop="post" label="职务"> </el-table-column>
				<el-table-column class="text" prop="sex" label="性别"> </el-table-column>
				<el-table-column class="text" prop="Company" label="单位"> </el-table-column>
				<el-table-column class="text" prop="number" label="预约号"> </el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	// import elCol from "@/components/el-col";
	import echarts from "echarts";
	import china from "echarts/map/json/china.json";
	echarts.registerMap("china", china);
	export default {
		//  components: { elCol },
		data() {
			return {
				wexamines: false,
				times: 0,
				masterPhone: '',
				theoryNum: '',
				xcxSwitchs: false,
				transfer: [{
						value: 'xsss',
						label: '学生宿舍'
					},
					{
						value: 'xyjws',
						label: '校园警务室'
					},
					{
						value: 'jxl',
						label: '教学楼安全'
					},
					{
						value: 'yjjy',
						label: '应急救援'
					},
					{
						value: 'wb',
						label: '网吧'
					},
					{
						value: 'xc',
						label: '校车安全'
					},
					{
						value: 'sd',
						label: '书店'
					},
					{
						value: 'wc',
						label: '重点车辆安全'
					},
					{
						value: 'kyc',
						label: '客运车安全'
					},
					{
						value: 'spxzf',
						label: '食品加工小作坊'
					},
					{
						value: 'bld',
						label: '便民超市'
					},
					{
						value: 'cydcf',
						label: '餐饮店厨房'
					},
					{
						value: 'tzc',
						label: '童装厂'
					},
					{
						value: 'czw',
						label: '居住出租屋'
					},
					{
						value: 'yjaq',
						label: '寄递安全'
					},
					{
						value: 'tzsb',
						label: '特种设备'
					},
					{
						value: 'dg',
						label: '施工用电安全'
					},
					{
						value: 'gjaq',
						label: '国家安全'
					},
					{
						value: 'jzsgaq',
						label: '建筑工地安全'
					},
					{
						value: 'stzl',
						label: '生态治理'
					},
					{
						value: 'rq',
						label: '燃气安全'
					},
					{
						value: 'aqsc',
						label: '生产车间'
					},
					{
						value: 'xj',
						label: '防范邪教'
					},
					{
						value: 'fank',
						label: '反恐防暴'
					},
					{
						value: 'weih',
						label: '危化企业'
					},
					{
						value: 'bmyd',
						label: '便民药店'
					},
					{
						value: "hxsys",
						label: '化学实验室'
					}
				],
				hwg_transfer: [],
				wgexamines: []
			};
		},
		mounted() {
			this.timess()
			this.xcxSwitch()
			this.hwgg_transfer()
			// this.initHistogramChart();
			this.getMasterPhone()
			this.getTheoryNum()
		},
		methods: {
			async timess() {
				const {
					data: res
				} = await this.$http.get('/examTime')
				this.times = res[0].state
			},
			
			async getMasterPhone() {
				const {
					data: res
				} = await this.$http.get('/setup/master_phone')
				if(res && res[0]){
					this.masterPhone = res[0].value
				}
			},
			
			async getTheoryNum() {
				const {
					data: res
				} = await this.$http.get('/setup/theory_num')
				if(res && res[0]){
					this.theoryNum = res[0].value
				}
			},
			
			async setup_ipt(name) {
				let body = {}
				if(name=='masterPhone'){
					body = {
						name: 'master_phone',
						value: this.masterPhone
					}
				}else if(name=='theoryNum'){
					body = {
						name: 'theory_num',
						value: this.theoryNum
					}
				}else{
					return false
				}
				
				const {
					data
				} = await this.$http.post('/setup/modify',  body)
				if (data.ok !== 1) return this.$message.error(res.mesg)
				this.$message.success('修改成功')
			},

			async hwg_ipt() {
				const {
					data
				} = await this.$http.post('/examTime/modify', {
					state: this.times
				})
				if (data.ok !== 1) return this.$message.error(res.mesg)
				this.$message.success('修改成功')
			},

			async xcxSwitch() {
				const {
					data: res
				} = await this.$http.get('/xcxSwitch')
				console.log(res);
				this.xcxSwitchs = res[0].state
			},

			async hwg_swt() {
				const {
					data
				} = await this.$http.post('/xcxSwitch/modify', {
					state: this.xcxSwitchs
				})
				if (data.ok !== 1) return this.$message.error(res.mesg)
				this.$message.success('修改成功')
			},
			// 考试选择
			async hwgg_transfer() {
				const {
					data: res
				} = await this.$http.get('/ksChoice')
				this.hwg_transfer = res[0].state
			},
			async hwg_transfers() {
				const {
					data
				} = await this.$http.post('/ksChoice/modify', {
					state: this.hwg_transfer
				})
				console.log(data);
				if (data.ok !== 1) return this.$message.error(res.mesg)
				this.$message.success('考题上传成功')
			},
			async examines() {
				this.wexamines = true
				const {
					data: res
				} = await this.$http.get('/examines')
				this.wgexamines = res[0].state
			},
			async adoptexamines() {
				for (const key in this.wgexamines) {
					console.log(this.wgexamines[key]);
					const {
						data: res
					} = await this.$http.post('sendmYYH', {
						numbers: this.wgexamines[key].mobile,
						number: this.wgexamines[key].number
					})
				}
				const {
					data
				} = await this.$http.post('/examines/modify', {
					state: []
				})
				this.$message.success('短信发送成功！')
			},
			async refuseexamines() {
				// console.log(this.wgexamines);
				for (const key in this.wgexamines) {
					const {
						data: res
					} = await this.$http.delete(`/appointment/remove/${this.wgexamines[key].id}`)
				}
				const {
					data
				} = await this.$http.post('/examines/modify', {
					state: []
				})
				this.$message.success('拒绝成功！')
			}
		}
	};
</script>

<style lang="less" scoped>
	.wxts {
		margin-bottom: 20px;

		a {
			color: #67c23a;
		}
	}

	.tj-card {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.color-ll {
			color: #34bfa3;
			font-size: 70px;
		}

		.color-yh {
			color: #d633ad;
			font-size: 70px;
		}

		.color-el {
			color: #d65e0e;
			font-size: 70px;
		}

		.color-sr {
			color: #f5c802;
			font-size: 70px;
		}

		.item {
			.item-title {
				padding: 10px;
				color: #909399;
			}

			.item-desc {
				padding: 10px;
				font-size: 28px;
				font-weight: bolder;
			}
		}
	}

	.hwg_ipt {
		width: 500px;
		margin-right: 20px;
	}

	.hwg_mb {
		margin-top: 50px;
	}

	.el-span {
		margin-left: 50px;
		margin-right: 15px;
	}

	.row_transfer {
		margin-top: 20px;
	}

	/deep/.row_transfer .el-button {
		margin-bottom: 5px;
	}

	.examine {
		margin-left: 20px;
	}
</style>
